import styled from 'styled-components';

export const CardSection = styled.div`
  display: flex;
  // using margin instead of padding so the margins can collapse when there are 2 next to each other
  margin: 24px;
  gap: 8px;
  flex-direction: column;
`;

export const CustomHairline = styled.div`
  background-color: var(--light-border-gray);
  margin: 0 24px;
  width: auto;
  height: 1px;
`;
